import { useEffect, useState, useContext } from "react";
import Utils from "./../Utils";
import { useSearchParams } from "react-router-dom";
import SSOLoginCard from "../components/login/SSOLoginCard";
import PhotographerLoginCard from "../components/login/PhotographerLoginCard";
import HotelOwnerLoginCard from "../components/login/HotelOwnerLoginCard";
import UserContext from "../contexts/UserContext";
import axios from "axios";
import _ from "lodash";

const Login = () => {
  const { logout } = useContext(UserContext);
  const [activeTab, setActiveTab] = useState("employee");
  const [impersonating, setImpersonating] = useState(false);
  const [searchParams] = useSearchParams();
  const ipToken = searchParams.get("ipToken");
  const uType = searchParams.get("uType");

  useEffect(() => {
    if (!_.isEmpty(ipToken) && !_.isEmpty(uType)) {
      setImpersonating(true);
      impersonateUserNow();
    } else if (Utils.isLoggedIn()) {
      if (
        Utils.isHR() ||
        Utils.isAMT() ||
        Utils.isPhotographer() ||
        Utils.isHotelOwner()
      ) {
        window.location.href = process.env.PUBLIC_URL + "/dashboard";
      }
    }

    document.body.className =
      "min-h-screen overflow-y-auto bg-slate-100 px-4 py-6 sm:px-6 sm:py-10";

    return () => {
      document.body.className = "bg-gray-50";
    };
  }, []);

  const impersonateUserNow = () => {
    logout();
    axios
      .post(
        Utils.apiUrl("frontend/auth/impersonateMe"),
        {
          ipToken: ipToken,
          uType: uType,
        },
        Utils.apiHeaders(),
      )
      .then((res) => {
        if (res.data.success) {
          Utils.setUserData(res.data);
          window.location.href = process.env.PUBLIC_URL + "/dashboard";
        }
      });
  };

  const tabs = [
    {
      key: "employee",
      label: "Marriott EID",
      icon: "fa-building",
    },
    {
      key: "photographer",
      label: "Photographer",
      icon: "fa-camera",
    },
    {
      key: "owner",
      label: "Owner Representative",
      icon: "fa-user-tie",
    },
  ];

  return (
    <div className="mx-auto w-full max-w-6xl">
      <div className="overflow-hidden rounded-2xl bg-white shadow-2xl ring-1 ring-slate-200">
        <div className="flex flex-col lg:flex-row min-h-[700px]">
          {/* LEFT SIDE */}
          <div
            className="relative hidden lg:flex w-full lg:w-[40%] bg-cover bg-center"
            style={{
              backgroundImage: `url(${process.env.PUBLIC_URL}/images/login-bg-left.png)`,
            }}
          >
            <div className="absolute inset-0 bg-black/30"></div>

            <div className="relative z-10 flex h-full flex-col justify-between p-10 text-white">
              <div>
                <h1 className="mb-4 text-center text-4xl font-bold leading-tight">
                  AURA
                </h1>
              </div>

              <div className="rounded-2xlp-4">
                <h2 className="mb-2 text-center text-2xl font-bold leading-tight">
                  Marriott APEC Photography Portal
                </h2>

                <p className="text-lg leading-8 text-slate-100">
                  <div className="text-md text-center">
                    - for Premium, Select & Mid-scale brands.
                  </div>
                  <br />
                  Guiding your brand photography journey from planning to final
                  approvals.
                </p>
              </div>
            </div>
          </div>

          {/* RIGHT SIDE */}
          <div
            className="flex w-full lg:w-[60%] items-center justify-center bg-white p-6 sm:p-10"
            style={{
              backgroundImage: `url(${process.env.PUBLIC_URL}/images/login-bg-right.png)`,
            }}
          >
            <div className="w-full max-w-xl">
              {/* LOGO MOBILE */}
              <div className="mb-8 flex justify-center lg:hidden">
                <img
                  src={`${process.env.PUBLIC_URL}/images/logo.png`}
                  alt="Logo"
                  className="max-w-[160px]"
                />
              </div>
              {impersonating && (
                <div
                  style={{ height: "500px" }}
                  className="my-10 py-10 rounded-lg bg-white p-4 text-center text-gray-800 text-xl"
                >
                  Impersonating user login, please wait..
                </div>
              )}
              {!impersonating && (
                <>
                  {/* TITLE */}
                  <div className="mb-8 text-center">
                    <h1 className="text-4xl font-bold text-slate-800">
                      Sign In
                    </h1>

                    <p className="mt-3 text-slate-500">
                      Select your login type below
                    </p>
                  </div>

                  {/* TABS */}
                  <div className="mb-8 rounded-xl border border-slate-200 bg-slate-50 p-2">
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
                      {tabs.map((tab) => (
                        <button
                          key={tab.key}
                          type="button"
                          onClick={() => setActiveTab(tab.key)}
                          className={`flex items-center justify-center gap-2 rounded-lg px-3 py-3 text-xs sm:text-sm font-semibold transition-all duration-200
                      
                      ${
                        activeTab === tab.key
                          ? "bg-blue-600 text-white shadow-lg"
                          : "bg-white text-slate-700 hover:bg-slate-100"
                      }
                    `}
                        >
                          <i className={`fas ${tab.icon}`}></i>
                          <span>{tab.label}</span>
                        </button>
                      ))}
                    </div>
                  </div>

                  {/* LOGIN FORM AREA */}
                  <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
                    {activeTab === "employee" && <SSOLoginCard />}

                    {activeTab === "photographer" && <PhotographerLoginCard />}

                    {activeTab === "owner" && <HotelOwnerLoginCard />}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
